export const LANGUAGES = [
  { label: 'Indonesian', languageCode: 'id' },
  { label: 'English', languageCode: 'en' },
  { label: 'German', languageCode: 'de' },
  { label: 'Spanish', languageCode: 'es' },
  { label: 'French', languageCode: 'fr' },
  { label: 'Portuguese', languageCode: 'pt' },
  { label: 'Russian', languageCode: 'ru' }
]

export const MAXIMUM_NUMBER_OF_AUTO_BETS = 1000

/* ==========================================================================
  HTTP Method Types
========================================================================== */
export const METHOD_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
}

/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
export const TOKEN = 'game_auth_token'
export const LANGUAGE = 'game_language'
export const OPERATOR_ID = 'game_operator_id'
export const ROLE = 'game_operator_role'

/* ==========================================================================
  All the navigation route Paths
========================================================================== */
export const ROUTE_PATHS = {
  // ----single routes------------
  home: '/',
  crashGame: '/crash-game',
  pyramidPlinkoGame: '/pyramid-plinko-game',
  kenoGame: '/keno-game',
  diceGame: '/dice-game',
  hiloGame: '/hilo-game',
  gongaMineGame: '/gonga-mine-game',
  coinFlipGame: '/coin-flip-game',
  bbCrossGame: '/cross-game',
  towerGame: '/tower-game'
}

/* ==========================================================================
Loader types
========================================================================== */
export const LOADER = {
  BUTTON: 'button',
  CONTENT: 'content',
  TABLE_CELL: 'tableCell'
}

/* ==========================================================================
  Loader Types
========================================================================== */
export const LOADER_HANDLER_TYPES = {
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader'
}

/* ==========================================================================
  Game Ids
========================================================================== */
export const DEFAULT_GAME_ID = {
  CRASH: 1,
  PYRAMID_PLINKO: 6,
  KENO: 7,
  DICE: 8,
  HILO: 10,
  GONGA_MINE: 14,
  COIN_FLIP: 17,
  CROSS: 23,
  TOWER: 24
}

/* ==========================================================================
  Game Result
========================================================================== */
export const BET_RESULT = {
  WON: 'won',
  LOST: 'lost',
  CANCELLED: 'cancelled'
}

export const S3_BUCKET_ENDPOINT = 'https://gs-custom-games-storage.s3.amazonaws.com'

export const S3_BUCKET_ENDPOINT_FAST_GAMES = 'https://fastgames-dev-storage.s3.amazonaws.com'

export const DEFAULT_PAGE_CALLS = 10

export const SPACE_DICE_AUTO_BET = {
  MIN: 1,
  MAX: 1000
}

/* ==========================================================================
  Currency Symbols
========================================================================== */
export const CURRENCY_SYMBOL = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  INR: '₹',
  AED: 'إ.د',
  VND: '₫',
  IDR: 'Rp',
  PHP: '₱',
  JPY: '¥',
  KRW: '₩',
  RUB: '₽',
  MYR: 'RM',
  THB: '฿',
  BRL: 'R$',
  CNY: '¥',
  CAD: '$',
  MXN: '$',
  NGN: '₦',
  TRY: '₺',
  NZD: '$',
  AUD: '$',
  ARS: '$',
  ILS: '₪',
  UAH: '₴',
  PLN: 'zł'
}

export const CURRENCIES = {
  // demo game currency
  FUN: { isFiat: true, precision: 2, symbol: 'FUN', label: 'Demo Currency', value: 'FUN' },
  // real game currency
  USD: { isFiat: true, precision: 2, symbol: '$', label: 'US Dollar', value: 'USD' },
  EUR: { isFiat: true, precision: 2, symbol: '€', label: 'Euro', value: 'EUR' },
  GBP: { isFiat: true, precision: 2, symbol: '£', label: 'British Pound', value: 'GBP' },
  CAD: { isFiat: true, precision: 2, symbol: 'C$', label: 'Canadian Dollar', value: 'CAD' },
  AUD: { isFiat: true, precision: 2, symbol: 'A$', label: 'Australian Dollar', value: 'AUD' },
  JPY: { isFiat: true, precision: 2, symbol: '¥', label: 'Japanese Yen', value: 'JPY' },
  CHF: { isFiat: true, precision: 2, symbol: 'CHF', label: 'Swiss Franc', value: 'CHF' },
  SEK: { isFiat: true, precision: 2, symbol: 'kr', label: 'Swedish Krona', value: 'SEK' },
  NOK: { isFiat: true, precision: 2, symbol: 'kr', label: 'Norwegian Krone', value: 'NOK' },
  NZD: { isFiat: true, precision: 2, symbol: 'NZ$', label: 'New Zealand Dollar', value: 'NZD' },
  SGD: { isFiat: true, precision: 2, symbol: 'S$', label: 'Singapore Dollar', value: 'SGD' },
  ZAR: { isFiat: true, precision: 2, symbol: 'R', label: 'South African Rand', value: 'ZAR' },
  HKD: { isFiat: true, precision: 2, symbol: 'HK$', label: 'Hong Kong Dollar', value: 'HKD' },
  INR: { isFiat: true, precision: 2, symbol: '₹', label: 'Indian Rupee', value: 'INR' },
  BRL: { isFiat: true, precision: 2, symbol: 'R$', label: 'Brazilian Real', value: 'BRL' },
  DKK: { isFiat: true, precision: 2, symbol: 'kr', label: 'Danish Krone', value: 'DKK' },
  PHP: { isFiat: true, precision: 2, symbol: '₱', label: 'Philippine Peso', value: 'PHP' },
  RUB: { isFiat: true, precision: 2, symbol: '₽', label: 'Russian Ruble', value: 'RUB' },
  THB: { isFiat: true, precision: 2, symbol: '฿', label: 'Thai Baht', value: 'THB' },
  TRY: { isFiat: true, precision: 2, symbol: '₺', label: 'Turkish Lira', value: 'TRY' },
  CZK: { isFiat: true, precision: 2, symbol: 'Kč', label: 'Czech Koruna', value: 'CZK' },
  CLP: { isFiat: true, precision: 2, symbol: 'CLP$', label: 'Chilean Peso', value: 'CLP' },
  MXN: { isFiat: true, precision: 2, symbol: 'MX$', label: 'Mexican Peso', value: 'MXN' },
  PLN: { isFiat: true, precision: 2, symbol: 'zł', label: 'Polish Zloty', value: 'PLN' },
  MYR: { isFiat: true, precision: 2, symbol: 'RM', label: 'Malaysian Ringgit', value: 'MYR' },
  RON: { isFiat: true, precision: 2, symbol: 'lei', label: 'Romanian Leu', value: 'RON' },
  BTC: { isFiat: false, precision: 8, symbol: '₿', label: 'Bitcoin', value: 'BTC' },
  ETH: { isFiat: false, precision: 8, symbol: 'Ξ', label: 'Ethereum', value: 'ETH' },
  BCH: { isFiat: false, precision: 8, symbol: 'BCH', label: 'Bitcoin Cash', value: 'BCH' },
  LTC: { isFiat: false, precision: 8, symbol: 'Ł', label: 'Litecoin', value: 'LTC' },
  XRP: { isFiat: false, precision: 8, symbol: 'XRP', label: 'Ripple', value: 'XRP' },
  ADA: { isFiat: false, precision: 8, symbol: 'ADA', label: 'Cardano', value: 'ADA' },
  DOGE: { isFiat: false, precision: 8, symbol: 'Ð', label: 'Dogecoin', value: 'DOGE' },
  USDT: { isFiat: false, precision: 8, symbol: 'USDT', label: 'Tether', value: 'USDT' },
  BNB: { isFiat: false, precision: 8, symbol: 'BNB', label: 'Binance Coin', value: 'BNB' },
  SOL: { isFiat: false, precision: 8, symbol: 'SOL', label: 'Solana', value: 'SOL' },
  DOT: { isFiat: false, precision: 8, symbol: 'DOT', label: 'Polkadot', value: 'DOT' },
  LINK: { isFiat: false, precision: 8, symbol: 'LINK', label: 'Chainlink', value: 'LINK' },
  TRX: { isFiat: false, precision: 8, symbol: 'TRX', label: 'Tron', value: 'TRX' },
  XLM: { isFiat: false, precision: 8, symbol: 'XLM', label: 'Stellar', value: 'XLM' },
  XMR: { isFiat: false, precision: 8, symbol: 'XMR', label: 'Monero', value: 'XMR' },
  DASH: { isFiat: false, precision: 8, symbol: 'DASH', label: 'Dash', value: 'DASH' },
  VET: { isFiat: false, precision: 8, symbol: 'VET', label: 'VeChain', value: 'VET' },
  ETC: { isFiat: false, precision: 8, symbol: 'ETC', label: 'Ethereum Classic', value: 'ETC' },
  NEO: { isFiat: false, precision: 8, symbol: 'NEO', label: 'Neo', value: 'NEO' },
  ZEC: { isFiat: false, precision: 8, symbol: 'ZEC', label: 'Zcash', value: 'ZEC' },
  ATOM: { isFiat: false, precision: 8, symbol: 'ATOM', label: 'Cosmos', value: 'ATOM' },
  ALGO: { isFiat: false, precision: 8, symbol: 'ALGO', label: 'Algorand', value: 'ALGO' },
  XTZ: { isFiat: false, precision: 8, symbol: 'XTZ', label: 'Tezos', value: 'XTZ' },
  FTM: { isFiat: false, precision: 8, symbol: 'FTM', label: 'Fantom', value: 'FTM' },
  EGLD: { isFiat: false, precision: 8, symbol: 'EGLD', label: 'Elrond', value: 'EGLD' }
}


export const WALLET_EMIT_TYPES = {
  CREDIT: 'credit',
  DEBIT: 'debit',
  RESOLVE: 'resolve',
  DEFAULT: 'default'
}

export const DEFAULT_AUTOBET_MAX_ROUNDS = 1000

export const ROUTE_GAME_NAME_ID = {
  [ROUTE_PATHS.crashGame]: DEFAULT_GAME_ID.CRASH,
  [ROUTE_PATHS.pyramidPlinkoGame]: DEFAULT_GAME_ID.PYRAMID_PLINKO,
  [ROUTE_PATHS.kenoGame]: DEFAULT_GAME_ID.KENO,
  [ROUTE_PATHS.diceGame]: DEFAULT_GAME_ID.DICE,
  [ROUTE_PATHS.hiloGame]: DEFAULT_GAME_ID.HILO,
  [ROUTE_PATHS.gongaMineGame]: DEFAULT_GAME_ID.GONGA_MINE,
  [ROUTE_PATHS.coinFlipGame]: DEFAULT_GAME_ID.COIN_FLIP,
  [ROUTE_PATHS.bbCrossGame]: DEFAULT_GAME_ID.CROSS,
  [ROUTE_PATHS.towerGame]: DEFAULT_GAME_ID.TOWER
}
